import { lazy } from "react";
import { Route } from "react-router-dom";
import { Error } from "./components/error";
import { Loading } from "./components/loading";

const IndustryTrending = lazy(() => import("./pages/industry-trending"));
const LeaderLagger = lazy(() => import("./pages/leader-lagger"));
const GainersLosers = lazy(() => import("./pages/gainers-losers"));
const MarketCap = lazy(() => import("./pages/market-cap"));
const DailyTradeProprietary = lazy(
  () => import("./pages/daily-trade-proprietary")
);
const DailyTradeForeign = lazy(() => import("./pages/daily-trade-foreign"));
const PEMarketValuation = lazy(() => import("./pages/pe-market-valuation"));
const PBMarketValuation = lazy(() => import("./pages/pb-market-valuation"));
const MAMarketValuation = lazy(() => import("./pages/ma-market-valuation"));
const MarketLiquidity = lazy(() => import("./pages/market-liquidity"));
const IndustryChange = lazy(() => import("./pages/industry-change"));
const HeatMap = lazy(() => import("./pages/heat-map"));
const TopForeignTrading = lazy(() => import("./pages/top-foreign-trading"));
const TopProprietaryTrading = lazy(
  () => import("./pages/top-proprietary-trading")
);
const MarketScatter = lazy(() => import("./pages/market-scatter"));
const OpenInterest = lazy(() => import("./pages/open-interest"));
const BasisPoint = lazy(() => import("./pages/basis-point"));

const Root = (
  <Route element={<Loading />} errorElement={<Error />}>
    <Route
      path="/"
      element={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          Market Watch by Vndirect
        </div>
      }
    />
    <Route path="/leader-lagger" element={<LeaderLagger />} />
    <Route path="/gainers-losers" element={<GainersLosers />} />
    <Route path="/market-cap" element={<MarketCap />} />
    <Route
      path="/daily-trade-proprietary"
      element={<DailyTradeProprietary />}
    />
    <Route path="/daily-trade-foreign" element={<DailyTradeForeign />} />
    <Route path="/pe-market-valuation" element={<PEMarketValuation />} />
    <Route path="/pb-market-valuation" element={<PBMarketValuation />} />

    <Route path="/ma-market-valuation" element={<MAMarketValuation />} />
    <Route path="/market-liquidity" element={<MarketLiquidity />} />
    <Route path="/industry-change" element={<IndustryChange />} />
    <Route path="/heat-map" element={<HeatMap />} />
    <Route path="/top-foreign-trading" element={<TopForeignTrading />} />
    <Route
      path="/top-proprietary-trading"
      element={<TopProprietaryTrading />}
    />
    <Route path="/market-scatter" element={<MarketScatter />} />
    <Route path="/open-interest" element={<OpenInterest />} />
    <Route path="/basis-point" element={<BasisPoint />} />
    <Route path="/industrytrending" element={<IndustryTrending />} />
  </Route>
);

export default Root;
